import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET_ALL: 'PRICING_MATRIX_GET',
  GET_ALL_SUCCESS: 'PRICING_MATRIX_GET_SUCCESS',
  GET_ALL_FAILURE: 'PRICING_MATRIX_GET_FAILURE',
};

export const getAll = actions.getAll(
  () => `${BASE_URL}/payment/subscription-plans/pricing-matrix/`,
  {
    PENDING: ACTIONS.GET_ALL,
    SUCCESS: ACTIONS.GET_ALL_SUCCESS,
    FAILURE: ACTIONS.GET_ALL_FAILURE,
  },
);
